export const locKeys = {
  vrTitle: "wizard.vr.tab.title.label",
  hotelTitle: "wizard.hotel.tab.title.label",
};
